<template>
    <div>
        <b-modal id="upload" title="Dosya Yükle" body-class="p-75" no-close-on-esc no-close-on-backdrop>
            <calculate-salary-process-bes-upload-file v-model="uploadObject" :upload-errors="uploadErrors"></calculate-salary-process-bes-upload-file>
            <template #modal-footer><v-executer :disabled="!uploadObject.File" :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <b-modal id="robot" title="Sihirbaz" body-class="p-75" no-close-on-esc no-close-on-backdrop hide-footer>
            <calculate-salary-process-bes-robot v-on:done="$event => done($event)"></calculate-salary-process-bes-robot>
        </b-modal>
        <b-card no-body class="mb-1">
            <v-table    ref="table"
                        :fields="fields"
                        name="bes"
                        :items-provider="provider"
                        pagination="server"
                        :settings="false">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3 mb-1 mb-md-0">             
                                    <b-input-group class="input-group-merge">
                                        <template #prepend>
                                            <b-input-group-text >
                                                <feather-icon icon="SearchIcon"></feather-icon>
                                            </b-input-group-text>
                                        </template>
                                        <b-form-input placeholder="Ara..." v-on:keyup.enter="$refs.table.refresh()" v-model="searchValue"></b-form-input>
                                    </b-input-group>
                                </div>
                                <div class="col-md-auto">
                                    <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto ml-auto">
                                    <button class="btn btn-primary w-100" v-on:click="upload">
                                        Dosya Yükle
                                    </button>
                                </div>
                                <div class="col-md-auto">
                                    <button class="btn btn-secondary w-100 d-flex" v-on:click="startRobot">
                                        <span class="material-icons-outlined d-block mr-50 f-1">auto_awesome</span>
                                        Sihirbazı Başlat
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template #filters>
                            <calculate-salary-process-bes-filter v-on:filter="filter"></calculate-salary-process-bes-filter>
                        </template>
                    </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import CalculateSalaryProcessBesUploadFile from './CalculateSalaryProcessBesUploadFile.vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'
import CalculateSalaryProcessBesFilter from './CalculateSalaryProcessBesFilter.vue'
import CalculateSalaryProcessBesRobot from './CalculateSalaryProcessBesRobot.vue'
import { BCard,BInputGroup, BInputGroupText, BFormInput, } from 'bootstrap-vue'

export default {
    components:{
        CalculateSalaryProcessBesUploadFile,
        CalculateSalaryProcessBesFilter,
        CalculateSalaryProcessBesRobot,
        BCard,
        BInputGroup, 
        BInputGroupText,
        BFormInput,
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Personel', key:'EmployeeFullName',thClass:'w-25'},
                {name:'Kimlik No', key:'IdentityNumber',thClass:'w-25'},
                {name:'Organizasyonel Şube', key:'BranchName',thClass:'w-25'},
                {name:'Son Güncellenme Tarihi', key:'Date',thClass:'w-25',sortable:true},
                {name:'Durum', key:'Active',tooltip:"Sorgulanan tarihteki ay için BES'in aktiflik durumunu gösteririr."},
                //{name:"Güncellik Durum",component:true,componentOptions:{name:"bes-status/BesStatus"},tooltip:'Sorgulanan tarihteki ay için BES bilgisinin yüklenip yüklenmediğinin durmunu gösteririr.'}
            ],
            uploadObject:{
                File:null,
            },
            filterData:{
                BranchId:null,
                Status:null,
                IsUpToDate:null
            },
            uploadErrors:[],
            searchValue:null
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        async uploadFile(){
            this.uploadErrors = []
            let formData = await Additional.ToFormData(this.uploadObject,['File'])
            this.loading = true
            EmployeeOperationsApi.Bes.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Data?.length == 0 && res.data.Success){
                    this.$hideModal('upload')
                    this.$refs.table.refresh()
                }
                else if(res.data.Success){
                    this.$refs.table.refresh()
                    this.uploadErrors = res.data.Data || []
                }else{
                    this.uploadErrors = res.data.Data || []
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        clearForm(){
            this.uploadObject.File = null
        },
        upload(){
            this.clearForm()
            this.$showModal('upload')
        },
        provider(data){
            return EmployeeOperationsApi.Bes.Table({
                Pagination:{
                    ...data,
                    QueryParam:this.searchValue || null
                },
                ...this.filterData
            })
        },
        startRobot(){
            this.$showModal('robot')
        },
        done(type){
            if(type == 'close'){
                this.$hideModal('robot')
            } else if (type == 'retry'){
                this.$hideModal('robot')
                this.$showModal('robot')
            } else if (type == 'refresh'){
                this.$hideModal('robot')
                this.$refs.table.refresh()
            }
        }
    }
}
</script>

<style>
.f-1{
    font-size: 1rem;
}
</style>